@if (isTopEditTab) {
  <ng-template iuDynamicContainer />
} @else {
  <iu-prime-fieldset
    [legend]="label"
    [toggleable]="toggleable && !this.isTopEditTab"
    [isSingleRow]="this.data.isSingleRow"
    [isAdditionalInfo]="this.data.isAdditionalInfo ? this.data.isAdditionalInfo : false"
    [(collapsed)]="collapsed"
    (openEmitter)="openInNewBlade()"
    [tableName]="this.data ? this.data.tableName : ''"
    [isReadOnly]="this.isReadOnly || this.data.isReadOnly"
    [contentStyleClass]="isTopEditTab ? 'blade-grid' : 'blade-part-width'">
    <!-- TODO: changer par la bonne logique quand le refactoring backend sera ok -->
    <ng-template iuDynamicContainer />
  </iu-prime-fieldset>
}
